import { defaultOpacity } from "../constants/constants";

const opacityReducer = (data = defaultOpacity, action) => {
    switch(action.type){
        case 'CHANGE_OPACITY':
            return action.data;
        default:
            return data;
    }
}

export default opacityReducer;